import { createAction, props } from "@ngrx/store";
import { EventFilter } from "@nai-libs/data-access";

export const setSelectedDay = createAction('[Schedule] Set selected date', props<{ selectedDay: Date }>());
export const setFilter = createAction('[Schedule] Set filter', props<{ filter: EventFilter }>());
export const clearFilter = createAction('[Schedule] Clear filters', props<{ filter: EventFilter }>());
